import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { Alert, Box, Button, Checkbox, FormControlLabel, Grid, IconButton, InputAdornment, Skeleton, TextField, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import { makeStyles } from '@mui/styles';
import MaterialUiPhoneNumber from 'material-ui-phone-number';
import * as React from 'react';
import { useHistory } from 'react-router';

import { CREATE, DataAPIContext } from '../api';
import AccessDeniedView from '../components/AccessDeniedView';
import AccessTagsDropdown from '../components/AccessTagsDropdown';
import FixedLinearProgress from '../components/FixedLinearProgress';
import FormActionButtons from '../components/FormActionButtons';
import FormLicenseeContext from '../components/FormLicenseeContext';
import PageMeta from '../components/PageMeta';
import { ContextStore } from '../store/contextStore';
import { disableMuiButton, enableMuiButton } from '../utils';
import { validateUser } from '../utils/validators';
import BlockRedirect from '../components/BlockRedirect';

const useStyles = makeStyles((theme) => ({
    root: {
        border: `1px solid ${grey[200]}`,
        borderRadius: '5px',
        margin: theme.spacing(2),
        maxHeight: 'calc(100svh - 6rem)',

        overflowY: 'auto',
        // [theme.breakpoints.down('sm')]: {
        //     maxHeight: 'calc(100svh - 6rem)',
        // },
    },
    gridRoot: {
        padding: theme.spacing(2),
    },
    tabButton: {
        borderRadius: '30px',
        textTransform: 'capitalize',
        fontWeight: 'normal',
    },
    buttonPanel: {
        marginTop: theme.spacing(4),
        backgroundColor: grey[100],
        // marginBottom: '2rem',

        // marginBottom: '2rem',
    },
}));

const TYPE_TRAVELER = 0;
const TYPE_STAFF = 1;

const UserCreate = (props) => {
    const dataAPI = React.useContext(DataAPIContext);
    const { hasPerm, currentLicensee } = React.useContext(ContextStore);
    const resource = 'user';
    const history = useHistory();
    const classes = useStyles();
    const saveRef = React.useRef(null);
    const [syncActive, setSyncActive] = React.useState(false);
    const [serverErrors, setServerErrors] = React.useState([]);
    const [user, setUser] = React.useState({
        type: TYPE_TRAVELER,
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        password1: '',
        password2: '',
        has_admin_access: false,
        tour_operator: currentLicensee || null,
        _changed: false,
    });
    const { canSave, errors } = validateUser(user);
    const is_staff = user.type === TYPE_STAFF;

    const handleNamedChange = (field, value, ev) => {
        console.log('XYZ handleNamedChange', field, value);
        setUser((prevState) => ({ ...prevState, [field]: value, _changed: field === 'type' ? false : true }));
    };
    const handleChange = (ev) => {
        const fid = `_changed_${ev.target.name}`;
        setUser((prevState) => ({ ...prevState, [ev.target.name]: ev.target.value, _changed: true, [fid]: true }));
    };
    const handleOnPhoneChange = (number, numberProps) => {
        setUser((prevState) => ({ ...prevState, phone: number, _changed: true, _changed_phone: true }));
    };
    const handleSave = (ev) => {
        console.log('save', user);
        setSyncActive(true);
        disableMuiButton(saveRef.current);
        (async () => {
            try {
                const res = await dataAPI(CREATE, resource, { data: user });
                console.log('create', res);
                if (res.statusCode === 201) {
                    setUser((prevUser) => ({ ...prevUser, _changed: false }));
                    setTimeout(() => {
                        history.push(`/user/${res.data.id}/edit`);
                    }, 0);
                } else if (res.statusCode === 406) {
                    console.log('validation errors', res.data);
                    setServerErrors(res.data.errors);
                }
            } finally {
                setSyncActive(false);
                if (saveRef && saveRef.current) {
                    enableMuiButton(saveRef.current);
                }
            }
        })();
    };

    const handleDelete = (ev) => {
        history.push('/user');
    };

    const onBlur = (ev) => {
        setUser((prevState) => ({ ...prevState, [ev.target.name + '_blured']: true }));
    };

    const onAccessTagsChange = (ev, atags, reason) => {
        setUser((prevState) => ({ ...prevState, atag: atags }));
    };

    if (!hasPerm('user', 'write')) {
        <AccessDeniedView />;
    }
    return (
        <div className={classes.root}>
            <PageMeta title="Create New User" />
            <BlockRedirect shouldBlock={!!user._changed} message="Are you sure you want to leave without saving changes?"/>
            <FixedLinearProgress visibility={syncActive} />
            <FormLicenseeContext.Provider value={user.tour_operator}>
            <div className={classes.gridRoot}>
                <Grid container direction="row" spacing={2}>
                    <Grid item xs={12}>
                        <Typography variant="h6">Create New User</Typography>
                    </Grid>
                    {/* <Grid item xs={2} container justify="flex-end" alignItems="center">
                        <Button aria-label="close-preview" onClick={handleDelete}>
                            <CloseIcon />
                        </Button>
                    </Grid> */}
                    <Grid item xs={6} sm={2}>
                        <Button variant={user.type === TYPE_TRAVELER ? 'contained' : 'outlined'} onClick={(ev) => handleNamedChange('type', TYPE_TRAVELER, ev)} size="small" color="primary" fullWidth className={classes.tabButton}>
                            Traveler
                        </Button>
                    </Grid>
                    <Grid item xs={6} sm={2}>
                        <Button variant={user.type === TYPE_STAFF ? 'contained' : 'outlined'} onClick={(ev) => handleNamedChange('type', TYPE_STAFF, ev)} size="small" color="primary" fullWidth className={classes.tabButton}>
                            Staff
                        </Button>
                    </Grid>
                    <Grid item xs={false} sm={8}></Grid>
                    <Grid item xs={12} sm={is_staff ? 6 : 12} container direction="row" spacing={2}>
                        <Grid item xs={12} sm={is_staff ? 12 : 6}>
                            <TextField {...errors['first_name']} variant="filled" size="small" fullWidth name="first_name" label="First Name" value={user.first_name} onChange={handleChange} onBlur={onBlur} />
                        </Grid>
                        <Grid item xs={12} sm={is_staff ? 12 : 6}>
                            <TextField variant="filled" size="small" fullWidth name="last_name" label="Last Name" value={user.last_name} onChange={handleChange} onBlur={onBlur} />
                        </Grid>
                        <Grid item xs={12} sm={is_staff ? 12 : 6}>
                            <TextField {...errors['email']} required variant="filled" size="small" fullWidth name="email" label="Email" value={user.email} onChange={handleChange} onBlur={onBlur} />
                        </Grid>
                        <Grid item xs={12} sm={is_staff ? 12 : 6}>
                            <MaterialUiPhoneNumber
                                variant="filled"
                                size="small"
                                name="phone"
                                label="Phone"
                                fullWidth
                                defaultCountry="us"
                                inputProps={{
                                    name: 'phone',
                                }}
                                onChange={handleOnPhoneChange}
                                value={user.phone || ''}
                            />
                        </Grid>
                        <Grid item xs={12} sm={is_staff ? 12 : 6}>
                            <AccessTagsDropdown value={user.atag} onChange={onAccessTagsChange} />
                        </Grid>
                        {is_staff ? (
                            <Grid item xs={12}>
                                <FormControlLabel control={<Checkbox color="primary" name="has_admin_access" checked={user.has_admin_access} onChange={(ev) => handleNamedChange('has_admin_access', !user.has_admin_access, ev)} />} label="Admin Access" />
                            </Grid>
                        ) : null}
                        {is_staff && user.has_admin_access ? (
                            <React.Fragment>
                                <Grid item xs={12} sm={12}>
                                    <TextField
                                        required
                                        {...errors['password1']}
                                        variant="filled"
                                        size="small"
                                        fullWidth
                                        type={user.password1visible ? 'text' : 'password'}
                                        name="password1"
                                        label="Password"
                                        value={user.password1}
                                        onChange={handleChange}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton tabIndex="-1" onClick={(ev) => handleNamedChange('password1visible', !user.password1visible, ev)}>
                                                        {user.password1visible ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                    <TextField
                                        required
                                        helperText=" "
                                        {...errors['password2']}
                                        variant="filled"
                                        size="small"
                                        fullWidth
                                        type={user.password2visible ? 'text' : 'password'}
                                        name="password2"
                                        label="Confirm Password"
                                        value={user.password2}
                                        onChange={handleChange}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton tabIndex="-1" onClick={(ev) => handleNamedChange('password2visible', !user.password2visible, ev)}>
                                                        {user.password2visible ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Grid>
                            </React.Fragment>
                        ) : null}
                    </Grid>
                    {is_staff ? (
                        <React.Fragment>
                            <Grid item xs={false} sm={1}></Grid>
                            <Grid item xs={12} sm={5} container direction="row" spacing={2}>
                                <Grid item xs={12}>
                                    <Typography variant="h6">Profile Image</Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant="circle" width={200} height={200} animation="wave" />
                                </Grid>
                            </Grid>
                        </React.Fragment>
                    ) : null}
                </Grid>
            </div>
            {serverErrors ? (
                <Box p={1}>
                    {serverErrors.map((e) => (
                        <Alert severity="error">{e}</Alert>
                    ))}
                </Box>
            ) : null}
            <Box p={1} className={classes.buttonPanel}>
                <FormActionButtons
                    submitRef={saveRef}
                    onSubmit={handleSave}
                    submitDisabled={!canSave}
                    onCancel={handleDelete}
                    cancelDisabled={syncActive}
                />
            </Box>
            </FormLicenseeContext.Provider>
        </div>
    );
};

export default UserCreate;
